var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "url(#paint0_linear_107_307)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98117 18.016C10.6048 17.1217 12.4173 16.3752 14.1108 15.6249C17.0242 14.3961 19.9492 13.1885 22.9038 12.0642C23.4786 11.8727 24.5115 11.6854 24.6128 12.5372C24.5573 13.7431 24.3291 14.9419 24.1727 16.1406C23.7755 18.7769 23.3165 21.4041 22.8688 24.0316C22.7146 24.9069 21.6182 25.3599 20.9166 24.7998C19.2307 23.661 17.5318 22.5333 15.8673 21.3681C15.3221 20.8141 15.8277 20.0185 16.3146 19.6229C17.7032 18.2544 19.1759 17.0917 20.4919 15.6525C20.8469 14.7953 19.798 15.5178 19.452 15.7391C17.551 17.0491 15.6965 18.4391 13.6923 19.5905C12.6685 20.154 11.4753 19.6724 10.452 19.358C9.53447 18.9781 8.18995 18.5953 8.98107 18.0161L8.98117 18.016Z",
    fill: "#F3F3F5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_307",
    x1: 17.9722,
    y1: -0.0557413,
    x2: 17.9722,
    y2: 36.3408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5DA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E6DC0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.b507c5476825c44f1e57df214c92057d.svg";
export { ForwardRef as ReactComponent };